import script from "./serviceList.vue?vue&type=script&setup=true&lang=js"
export * from "./serviceList.vue?vue&type=script&setup=true&lang=js"

import "./serviceList.vue?vue&type=style&index=0&id=3a677e73&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a677e73"]])

export default __exports__